"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getAccountShapeWithAPI = void 0;
var jsHelpers_1 = require("../../bridge/jsHelpers");
var types_1 = require("../../types");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var account_1 = require("../../account");
var web3_1 = require("./api/chain/web3");
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var operation_1 = require("../../operation");
var logic_1 = require("./logic");
var fp_1 = require("lodash/fp");
var program_1 = require("./api/chain/program");
var utils_1 = require("./utils");
var getAccountShapeWithAPI = function (info, api) { return __awaiter(void 0, void 0, void 0, function () {
    var mainAccAddress, mainInitialAcc, currency, derivationMode, _a, blockHeight, mainAccBalance, mainAccSpendableBalance, onChaintokenAccounts, onChainStakes, mainAccountId, onChainTokenAccsByMint, subAccByMint, nextSubAccs, _loop_1, _b, _c, _d, mint, accs, e_1_1, epoch, stakes, sortedStakes, mainAccountLastTxSignature, newMainAccTxs, newMainAccOps, mainAccTotalOperations, shape;
    var e_1, _e;
    var _f, _g, _h;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                mainAccAddress = info.address, mainInitialAcc = info.initialAccount, currency = info.currency, derivationMode = info.derivationMode;
                return [4 /*yield*/, getAccount(mainAccAddress, api)];
            case 1:
                _a = _j.sent(), blockHeight = _a.blockHeight, mainAccBalance = _a.balance, mainAccSpendableBalance = _a.spendableBalance, onChaintokenAccounts = _a.tokenAccounts, onChainStakes = _a.stakes;
                mainAccountId = (0, types_1.encodeAccountId)({
                    type: "js",
                    version: "2",
                    currencyId: currency.id,
                    xpubOrAddress: mainAccAddress,
                    derivationMode: derivationMode
                });
                onChainTokenAccsByMint = (0, fp_1.pipe)(function () { return onChaintokenAccounts; }, (0, fp_1.groupBy)(function (_a) {
                    var mint = _a.info.mint;
                    return mint.toBase58();
                }), function (v) { return new Map((0, fp_1.toPairs)(v)); })();
                subAccByMint = (0, fp_1.pipe)(function () { var _a; return (_a = mainInitialAcc === null || mainInitialAcc === void 0 ? void 0 : mainInitialAcc.subAccounts) !== null && _a !== void 0 ? _a : []; }, (0, fp_1.filter)(function (subAcc) { return subAcc.type === "TokenAccount"; }), (0, fp_1.keyBy)(function (subAcc) { return (0, logic_1.toTokenMint)(subAcc.token.id); }), function (v) { return new Map((0, fp_1.toPairs)(v)); })();
                nextSubAccs = [];
                _loop_1 = function (mint, accs) {
                    var assocTokenAccAddress, assocTokenAcc, subAcc, lastSyncedTxSignature, txs, nextSubAcc;
                    return __generator(this, function (_k) {
                        switch (_k.label) {
                            case 0:
                                if (!(0, logic_1.tokenIsListedOnLedger)(mint)) {
                                    return [2 /*return*/, "continue"];
                                }
                                return [4 /*yield*/, api.findAssocTokenAccAddress(mainAccAddress, mint)];
                            case 1:
                                assocTokenAccAddress = _k.sent();
                                assocTokenAcc = accs.find(function (_a) {
                                    var pubkey = _a.onChainAcc.pubkey;
                                    return pubkey.toBase58() === assocTokenAccAddress;
                                });
                                if (assocTokenAcc === undefined) {
                                    return [2 /*return*/, "continue"];
                                }
                                subAcc = subAccByMint.get(mint);
                                lastSyncedTxSignature = (_f = subAcc === null || subAcc === void 0 ? void 0 : subAcc.operations) === null || _f === void 0 ? void 0 : _f[0].hash;
                                return [4 /*yield*/, (0, web3_1.getTransactions)(assocTokenAcc.onChainAcc.pubkey.toBase58(), lastSyncedTxSignature, api)];
                            case 2:
                                txs = _k.sent();
                                nextSubAcc = subAcc === undefined
                                    ? newSubAcc({
                                        mainAccountId: mainAccountId,
                                        assocTokenAcc: assocTokenAcc,
                                        txs: txs
                                    })
                                    : patchedSubAcc({
                                        subAcc: subAcc,
                                        assocTokenAcc: assocTokenAcc,
                                        txs: txs
                                    });
                                nextSubAccs.push(nextSubAcc);
                                return [2 /*return*/];
                        }
                    });
                };
                _j.label = 2;
            case 2:
                _j.trys.push([2, 7, 8, 9]);
                _b = __values(onChainTokenAccsByMint.entries()), _c = _b.next();
                _j.label = 3;
            case 3:
                if (!!_c.done) return [3 /*break*/, 6];
                _d = __read(_c.value, 2), mint = _d[0], accs = _d[1];
                return [5 /*yield**/, _loop_1(mint, accs)];
            case 4:
                _j.sent();
                _j.label = 5;
            case 5:
                _c = _b.next();
                return [3 /*break*/, 3];
            case 6: return [3 /*break*/, 9];
            case 7:
                e_1_1 = _j.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 9];
            case 8:
                try {
                    if (_c && !_c.done && (_e = _b["return"])) _e.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 9: return [4 /*yield*/, api.getEpochInfo()];
            case 10:
                epoch = (_j.sent()).epoch;
                stakes = onChainStakes.map(function (_a) {
                    var account = _a.account, activation = _a.activation, reward = _a.reward;
                    var _b = account.info, meta = _b.meta, stake = _b.stake;
                    var rentExemptReserve = account.info.meta.rentExemptReserve.toNumber();
                    var stakeAccBalance = account.onChainAcc.account.lamports;
                    var hasWithdrawAuth = meta.authorized.withdrawer.toBase58() === mainAccAddress &&
                        !(0, logic_1.isStakeLockUpInForce)({
                            lockup: meta.lockup,
                            custodianAddress: mainAccAddress,
                            epoch: epoch
                        });
                    return {
                        stakeAccAddr: account.onChainAcc.pubkey.toBase58(),
                        stakeAccBalance: stakeAccBalance,
                        rentExemptReserve: rentExemptReserve,
                        hasStakeAuth: meta.authorized.staker.toBase58() === mainAccAddress,
                        hasWithdrawAuth: hasWithdrawAuth,
                        delegation: stake === null
                            ? undefined
                            : {
                                stake: activation.state === "inactive"
                                    ? 0
                                    : stake.delegation.stake.toNumber(),
                                voteAccAddr: stake.delegation.voter.toBase58()
                            },
                        activation: activation,
                        withdrawable: hasWithdrawAuth
                            ? (0, logic_1.withdrawableFromStake)({
                                stakeAccBalance: stakeAccBalance,
                                activation: activation,
                                rentExemptReserve: rentExemptReserve
                            })
                            : 0,
                        reward: reward === null
                            ? undefined
                            : {
                                amount: reward.amount
                            }
                    };
                });
                sortedStakes = (0, fp_1.flow)(function () { return stakes; }, (0, fp_1.sortBy)([
                    function (stake) { var _a, _b; return -((_b = (_a = stake.delegation) === null || _a === void 0 ? void 0 : _a.stake) !== null && _b !== void 0 ? _b : 0); },
                    function (stake) { return -stake.withdrawable; },
                    function (stake) { return -stake.stakeAccAddr; },
                ]))();
                mainAccountLastTxSignature = (_g = mainInitialAcc === null || mainInitialAcc === void 0 ? void 0 : mainInitialAcc.operations[0]) === null || _g === void 0 ? void 0 : _g.hash;
                return [4 /*yield*/, (0, web3_1.getTransactions)(mainAccAddress, mainAccountLastTxSignature, api)];
            case 11:
                newMainAccTxs = _j.sent();
                newMainAccOps = newMainAccTxs
                    .map(function (tx) { return txToMainAccOperation(tx, mainAccountId, mainAccAddress); })
                    .filter(function (op) { return op !== undefined; });
                mainAccTotalOperations = (0, jsHelpers_1.mergeOps)((_h = mainInitialAcc === null || mainInitialAcc === void 0 ? void 0 : mainInitialAcc.operations) !== null && _h !== void 0 ? _h : [], newMainAccOps);
                shape = {
                    // uncomment when tokens are supported
                    // subAccounts as undefined makes TokenList disappear in desktop
                    //subAccounts: nextSubAccs,
                    id: mainAccountId,
                    blockHeight: blockHeight,
                    balance: mainAccBalance,
                    spendableBalance: mainAccSpendableBalance,
                    operations: mainAccTotalOperations,
                    operationsCount: mainAccTotalOperations.length,
                    solanaResources: {
                        stakes: sortedStakes
                    }
                };
                return [2 /*return*/, shape];
        }
    });
}); };
exports.getAccountShapeWithAPI = getAccountShapeWithAPI;
function newSubAcc(_a) {
    var _b;
    var mainAccountId = _a.mainAccountId, assocTokenAcc = _a.assocTokenAcc, txs = _a.txs;
    var firstTx = txs[txs.length - 1];
    var creationDate = new Date(((_b = firstTx.info.blockTime) !== null && _b !== void 0 ? _b : Date.now() / 1000) * 1000);
    var tokenId = (0, logic_1.toTokenId)(assocTokenAcc.info.mint.toBase58());
    var tokenCurrency = (0, cryptoassets_1.getTokenById)(tokenId);
    var accosTokenAccPubkey = assocTokenAcc.onChainAcc.pubkey;
    var accountId = (0, logic_1.encodeAccountIdWithTokenAccountAddress)(mainAccountId, accosTokenAccPubkey.toBase58());
    var balance = new bignumber_js_1["default"](assocTokenAcc.info.tokenAmount.amount);
    var newOps = (0, fp_1.compact)(txs.map(function (tx) { return txToTokenAccOperation(tx, assocTokenAcc, accountId); }));
    return {
        balance: balance,
        balanceHistoryCache: account_1.emptyHistoryCache,
        creationDate: creationDate,
        id: accountId,
        parentId: mainAccountId,
        operations: (0, jsHelpers_1.mergeOps)([], newOps),
        operationsCount: txs.length,
        pendingOperations: [],
        spendableBalance: balance,
        starred: false,
        swapHistory: [],
        token: tokenCurrency,
        type: "TokenAccount"
    };
}
function patchedSubAcc(_a) {
    var subAcc = _a.subAcc, assocTokenAcc = _a.assocTokenAcc, txs = _a.txs;
    var balance = new bignumber_js_1["default"](assocTokenAcc.info.tokenAmount.amount);
    var newOps = (0, fp_1.compact)(txs.map(function (tx) { return txToTokenAccOperation(tx, assocTokenAcc, subAcc.id); }));
    var totalOps = (0, jsHelpers_1.mergeOps)(subAcc.operations, newOps);
    return __assign(__assign({}, subAcc), { balance: balance, spendableBalance: balance, operations: totalOps });
}
function txToMainAccOperation(tx, accountId, accountAddress) {
    if (!tx.info.blockTime || !tx.parsed.meta) {
        return undefined;
    }
    var message = tx.parsed.transaction.message;
    var accountIndex = message.accountKeys.findIndex(function (pma) { return pma.pubkey.toBase58() === accountAddress; });
    if (accountIndex < 0) {
        return undefined;
    }
    var _a = tx.parsed.meta, preBalances = _a.preBalances, postBalances = _a.postBalances;
    var balanceDelta = new bignumber_js_1["default"](postBalances[accountIndex]).minus(new bignumber_js_1["default"](preBalances[accountIndex]));
    var isFeePayer = accountIndex === 0;
    var txFee = new bignumber_js_1["default"](tx.parsed.meta.fee);
    var opType = getMainAccOperationType({
        tx: tx.parsed.transaction,
        fee: txFee,
        isFeePayer: isFeePayer,
        balanceDelta: balanceDelta
    });
    var accum = {
        senders: [],
        recipients: []
    };
    var _b = opType === "IN" || opType === "OUT"
        ? message.accountKeys.reduce(function (acc, account, i) {
            var delta = new bignumber_js_1["default"](postBalances[i]).minus(new bignumber_js_1["default"](preBalances[i]));
            if (delta.lt(0)) {
                var shouldConsiderAsSender = i > 0 || !delta.negated().eq(txFee);
                if (shouldConsiderAsSender) {
                    acc.senders.push(account.pubkey.toBase58());
                }
            }
            else if (delta.gt(0)) {
                acc.recipients.push(account.pubkey.toBase58());
            }
            return acc;
        }, accum)
        : accum, senders = _b.senders, recipients = _b.recipients;
    var txHash = tx.info.signature;
    var txDate = new Date(tx.info.blockTime * 1000);
    var opFee = isFeePayer ? txFee : new bignumber_js_1["default"](0);
    var value = balanceDelta.abs();
    var opValue = opType === "OPT_OUT" ? value.negated() : value;
    return {
        id: (0, operation_1.encodeOperationId)(accountId, txHash, opType),
        hash: txHash,
        accountId: accountId,
        hasFailed: !!tx.info.err,
        blockHeight: tx.info.slot,
        blockHash: message.recentBlockhash,
        extra: getOpExtra(tx),
        type: opType,
        senders: senders,
        recipients: recipients,
        date: txDate,
        value: opValue,
        fee: opFee
    };
}
function getOpExtra(tx) {
    var extra = {};
    if (tx.info.memo !== null) {
        extra.memo = dropMemoLengthPrefixIfAny(tx.info.memo);
    }
    return extra;
}
function txToTokenAccOperation(tx, assocTokenAcc, accountId) {
    var _a, _b;
    if (!tx.info.blockTime || !tx.parsed.meta) {
        return undefined;
    }
    var assocTokenAccIndex = tx.parsed.transaction.message.accountKeys.findIndex(function (v) {
        return v.pubkey.equals(assocTokenAcc.onChainAcc.pubkey);
    });
    if (assocTokenAccIndex < 0) {
        return undefined;
    }
    var _c = tx.parsed.meta, preTokenBalances = _c.preTokenBalances, postTokenBalances = _c.postTokenBalances;
    var preTokenBalance = preTokenBalances === null || preTokenBalances === void 0 ? void 0 : preTokenBalances.find(function (b) { return b.accountIndex === assocTokenAccIndex; });
    var postTokenBalance = postTokenBalances === null || postTokenBalances === void 0 ? void 0 : postTokenBalances.find(function (b) { return b.accountIndex === assocTokenAccIndex; });
    var delta = new bignumber_js_1["default"]((_a = postTokenBalance === null || postTokenBalance === void 0 ? void 0 : postTokenBalance.uiTokenAmount.amount) !== null && _a !== void 0 ? _a : 0).minus(new bignumber_js_1["default"]((_b = preTokenBalance === null || preTokenBalance === void 0 ? void 0 : preTokenBalance.uiTokenAmount.amount) !== null && _b !== void 0 ? _b : 0));
    var opType = getTokenAccOperationType({ tx: tx.parsed.transaction, delta: delta });
    var txHash = tx.info.signature;
    var _d = getTokenSendersRecipients({
        meta: tx.parsed.meta,
        accounts: tx.parsed.transaction.message.accountKeys
    }), senders = _d.senders, recipients = _d.recipients;
    return {
        id: (0, operation_1.encodeOperationId)(accountId, txHash, opType),
        accountId: accountId,
        type: opType,
        hash: txHash,
        date: new Date(tx.info.blockTime * 1000),
        blockHeight: tx.info.slot,
        fee: new bignumber_js_1["default"](0),
        recipients: recipients,
        senders: senders,
        value: delta.abs(),
        hasFailed: !!tx.info.err,
        extra: getOpExtra(tx),
        blockHash: tx.parsed.transaction.message.recentBlockhash
    };
}
function getMainAccOperationType(_a) {
    var tx = _a.tx, fee = _a.fee, isFeePayer = _a.isFeePayer, balanceDelta = _a.balanceDelta;
    var type = getMainAccOperationTypeFromTx(tx);
    if (type !== undefined) {
        return type;
    }
    return isFeePayer && balanceDelta.negated().eq(fee)
        ? "FEES"
        : balanceDelta.lt(0)
            ? "OUT"
            : balanceDelta.gt(0)
                ? "IN"
                : "NONE";
}
function getMainAccOperationTypeFromTx(tx) {
    var instructions = tx.message.instructions;
    var parsedIxs = instructions
        .map(function (ix) { return (0, program_1.parseQuiet)(ix); })
        .filter(function (_a) {
        var program = _a.program;
        return program !== "spl-memo";
    });
    if (parsedIxs.length === 3) {
        var _a = __read(parsedIxs, 3), first = _a[0], second = _a[1], third = _a[2];
        if (first.program === "system" &&
            (first.instruction.type === "createAccountWithSeed" ||
                first.instruction.type === "createAccount") &&
            second.program === "stake" &&
            second.instruction.type === "initialize" &&
            third.program === "stake" &&
            third.instruction.type === "delegate") {
            return "DELEGATE";
        }
    }
    if (parsedIxs.length === 1) {
        var first = parsedIxs[0];
        switch (first.program) {
            case "spl-associated-token-account":
                switch (first.instruction.type) {
                    case "associate":
                        return "OPT_IN";
                }
                // needed for lint
                break;
            case "spl-token":
                switch (first.instruction.type) {
                    case "closeAccount":
                        return "OPT_OUT";
                }
                break;
            case "stake":
                switch (first.instruction.type) {
                    case "delegate":
                        return "DELEGATE";
                    case "deactivate":
                        return "UNDELEGATE";
                    case "withdraw":
                        return "IN";
                }
                break;
            default:
                return undefined;
        }
    }
    return undefined;
}
function getTokenSendersRecipients(_a) {
    var meta = _a.meta, accounts = _a.accounts;
    var preTokenBalances = meta.preTokenBalances, postTokenBalances = meta.postTokenBalances;
    return accounts.reduce(function (accum, account, i) {
        var preTokenBalance = preTokenBalances === null || preTokenBalances === void 0 ? void 0 : preTokenBalances.find(function (b) { return b.accountIndex === i; });
        var postTokenBalance = postTokenBalances === null || postTokenBalances === void 0 ? void 0 : postTokenBalances.find(function (b) { return b.accountIndex === i; });
        if (preTokenBalance && postTokenBalance) {
            var tokenDelta = new bignumber_js_1["default"](postTokenBalance.uiTokenAmount.amount).minus(new bignumber_js_1["default"](preTokenBalance.uiTokenAmount.amount));
            if (tokenDelta.lt(0)) {
                accum.senders.push(account.pubkey.toBase58());
            }
            else if (tokenDelta.gt(0)) {
                accum.recipients.push(account.pubkey.toBase58());
            }
        }
        return accum;
    }, {
        senders: [],
        recipients: []
    });
}
function getTokenAccOperationType(_a) {
    var tx = _a.tx, delta = _a.delta;
    var instructions = tx.message.instructions;
    var _b = __read(instructions
        .map(function (ix) { return (0, program_1.parseQuiet)(ix); })
        .filter(function (_a) {
        var program = _a.program;
        return program !== "spl-memo";
    })), mainIx = _b[0], otherIxs = _b.slice(1);
    if (mainIx !== undefined && otherIxs.length === 0) {
        switch (mainIx.program) {
            case "spl-associated-token-account":
                switch (mainIx.instruction.type) {
                    case "associate":
                        return "OPT_IN";
                }
        }
    }
    var fallbackType = delta.eq(0) ? "NONE" : delta.gt(0) ? "IN" : "OUT";
    return fallbackType;
}
function dropMemoLengthPrefixIfAny(memo) {
    var lengthPrefixMatch = memo.match(/^\[(\d+)\]\s/);
    if (lengthPrefixMatch) {
        var prefixLength = Number(lengthPrefixMatch[1]);
        if (Number.isInteger(prefixLength) && prefixLength < memo.length) {
            return memo.slice(-prefixLength);
        }
    }
    return memo;
}
function getAccount(address, api) {
    return __awaiter(this, void 0, void 0, function () {
        var balanceLamportsWithContext, tokenAccounts, stakeAccountsRaw, _a, _b, stakeAccounts, stakes, balance, blockHeight;
        var _this = this;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, api.getBalanceAndContext(address)];
                case 1:
                    balanceLamportsWithContext = _c.sent();
                    tokenAccounts = [];
                    _a = [[]];
                    return [4 /*yield*/, api.getStakeAccountsByStakeAuth(address)];
                case 2:
                    _b = [__spreadArray.apply(void 0, _a.concat([__read.apply(void 0, [(_c.sent())]), false]))];
                    return [4 /*yield*/, api.getStakeAccountsByWithdrawAuth(address)];
                case 3:
                    stakeAccountsRaw = __spreadArray.apply(void 0, _b.concat([__read.apply(void 0, [(_c.sent())]), false]));
                    stakeAccounts = (0, fp_1.flow)(function () { return stakeAccountsRaw; }, (0, fp_1.uniqBy)(function (acc) { return acc.pubkey.toBase58(); }), (0, fp_1.map)(web3_1.toStakeAccountWithInfo), fp_1.compact)();
                    return [4 /*yield*/, (0, utils_1.drainSeq)(stakeAccounts.map(function (account) { return function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = {
                                            account: account
                                        };
                                        return [4 /*yield*/, api.getStakeActivation(account.onChainAcc.pubkey.toBase58())];
                                    case 1: return [2 /*return*/, (_a.activation = _b.sent(),
                                            //reward: stakeRewards[idx],
                                            _a.reward = null,
                                            _a)];
                                }
                            });
                        }); }; }))];
                case 4:
                    stakes = _c.sent();
                    balance = new bignumber_js_1["default"](balanceLamportsWithContext.value);
                    blockHeight = balanceLamportsWithContext.context.slot;
                    return [2 /*return*/, {
                            balance: balance,
                            spendableBalance: balance,
                            blockHeight: blockHeight,
                            tokenAccounts: tokenAccounts,
                            stakes: stakes
                        }];
            }
        });
    });
}
//# sourceMappingURL=js-synchronization.js.map